module.exports = __webpack_public_path__ + "static/pakmaya-global-pazarlama-b77737f04b1faa56b47e2f2490cc30e2.png";